(ns teamoesterreich.admin-mode.administration.my-setup
  (:require [clojure.string :as str]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.setup :as setup]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.syncer :as syncer]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.admin-mode.data.organisation :as d-organisation]
            [teamoesterreich.view-state :as v-state]

            ))


(defn my-cockpit [!me]
  [mui/card-content

   [mui/typography "Meine Cockpit Einstellungen"]

   [mui/button {:color "primary"
                :href (let [keycloak-url (:keycloak-url setup/config)]
                (str (if (str/ends-with? keycloak-url "/") keycloak-url (str keycloak-url "/")) "account"))}
    "Account-Portal (Passwort/2FA ändern)"]

   ;(when (d-rights/allow-admin-for d-rights/USER)
   ;  [:div
   ;   [mui/form-control-label {:label     "Person `Identität bestätigen` Todos anzeigen"
   ;                            :value     ""
   ;                            :placement "start"
   ;                            :control   (r/as-element [mui/checkbox {}])}]
   ;   [:br]])
   ;
   ;(when (d-rights/allow-admin-for d-rights/USER)
   ;  [:div
   ;   [mui/form-control-label {:label     "Person `Personalstatus bestätigen` Todos anzeigen"
   ;                            :value     ""
   ;                            :placement "start"
   ;                            :control   (r/as-element [mui/checkbox {}])}]
   ;   [:br]])
   ;
   ;(when (d-rights/allow-admin-for d-rights/LEBENSRETTER)
   ;  [:div
   ;   [mui/form-control-label {:label     "Person `Rezertifizierung bestätigen` Todos anzeigen"
   ;                            :value     ""
   ;                            :placement "start"
   ;                            :control   (r/as-element [mui/checkbox {}])}]
   ;   [:br]])
   ;
   ;(when (d-rights/allow-admin-for d-rights/CLASSIC_ACTIVATE)
   ;  [:div
   ;   [mui/form-control-label {:label     "Einsatz `Einsatz zur Freigabe` Todos anzeigen"
   ;                            :value     ""
   ;                            :placement "start"
   ;                            :control   (r/as-element [mui/checkbox {}])}]
   ;   ])

   ]
  )
(defn my-rights [!me]
  (let [_ (d-organisation/get-store-organisations)
        !organisations (r/cursor v-state/app-state [:organisations])
        dep-mask-list (or (d-organisation/get-lv-filter-list @!organisations) [])
        dst-mask-list (reduce (fn [c [k m]] (assoc c k m)) {} (or (d-organisation/get-dest-list @!organisations) []))]
    [mui/card-content
     [mui/typography "Meine Rechte"]

     (if (d-rights/is-superuser?)
       [:div "Ich bin Superuser"]
       (let [rights (reduce (fn [c e]
                              (let [mask (str (:right-organisationMask e))
                                    section (:right-section e)]
                                (conj c (merge e
                                               [:right (or (:name (get d-rights/RIGHTS_LIST section)) section)]
                                               [:organisationDepartment (or (get dep-mask-list mask)
                                                                            (reduce (fn [c [m n]] (if (re-find (re-pattern m) mask) n c)) "-" dep-mask-list))]
                                               [:organisation (or (get dst-mask-list mask) "-")]
                                               [:right-organisationMask mask]
                                               )))) [] (d-rights/get-my-admin-right-list))]
         [mui/table
          [mui/table-head
           [mui/table-row
            [mui/table-cell "Rolle"]
            [mui/table-cell (txt/txt :rights-level 1)]
            [mui/table-cell (txt/txt :rights-level 2)]
            [mui/table-cell (txt/txt :rights-level 3)]
            ]]
          [mui/table-body
           (for [rgh (sort-by :right-organisationMask (filter :right-active rights))]
             (let [section (:right-section rgh)]
               ^{:key (str "RIGHT_ROW_-" (:right-uuid rgh))}
               [mui/table-row
                [mui/table-cell (or (:name (get (into {} d-rights/RIGHTS_LIST) section)) (str (:right-uuid rgh) " `" section "`"))]
                [mui/table-cell (:organisationMain rgh)]
                [mui/table-cell (:organisationDepartment rgh)]
                [mui/table-cell (:organisation rgh)]
                ]))
           ]]
         )
       )])
  )
(defn checkbox-helper [actual-user !edited name key]
  (let [val (if-not (nil? (get @!edited key)) (get @!edited key)
                                              (if-not (nil? (get actual-user key)) (get actual-user key) false))
        changed? (and (not (nil? (get @!edited key))) (not= (get @!edited key) (or (get actual-user key) false)))]
    [mui/form-control-label {:style     {:backgroundColor (if changed? "#ffd6d2" "#ffffff")}
                             :label     (str name )
                             :value     (if (false? val) true false)
                             :checked   (if (false? val) true false)
                             :onChange  (fn [_ b]
                                          (log/debug ":user-adminNoMailUserSummary " val "->" (not b))
                                          (swap! !edited assoc key (not b)))
                             :placement "start"
                             :control   (r/as-element [mui/checkbox {}])}]))

(defn my-email-setup [!st !me]
  (let [actual-user @!me
        !edited (r/cursor !st [:edited])
        changed-fn (fn [key])
        actual-val-fn (fn [key & [def]])]
    [mui/card-content

     [mui/typography "Meine Email Einstellungen"]


     [checkbox-helper actual-user !edited "Wochen Zusammenfassung mailen" :user-adminNoMailUserSummary]
     [:br]
     [checkbox-helper actual-user !edited "Neue Teilnehmer in meiner Region" :user-adminNoMailUserNew]
     [:br]
     [checkbox-helper actual-user !edited "Neue Teilnehmer-Dokumente täglich" :user-adminNoMailUserNewDocuments]
     [:br]
     [checkbox-helper actual-user !edited "Neue Lebensretter in meiner Region" :user-adminNoMailNewLr]
     [:br]
     [checkbox-helper actual-user !edited "Einsatzinfo Lebensretter" :user-adminNoMailLrIntervention]
     [:br]
     [checkbox-helper actual-user !edited "Einsatzinfo Firstresponder" :user-adminNoMailFrIntervention]
     [:br]
     [checkbox-helper actual-user !edited "Einsatzinfo Peer Anfrage" :user-adminNoMailPeerRequest]
     [:br]
     [mui/card-actions

      [mui/button {
                   :color   "secondary"
                   :variant "contained"
                   :onClick #(reset! !edited {})
                   } "Abbrechen"]
      (when (reduce (fn [c [k v]] (or c (not= (get @!me k) v))) false @!edited)
        [mui/button {
                     :color   "primary"
                     :variant "contained"
                     :onClick (fn []
                                (d-user/>user-edit-field (:user-uuid @!me)
                                                         (merge @!edited)
                                                         (fn []
                                                           (reset! !edited {})
                                                           (syncer/get-me)
                                                           )))
                     } "Speichern"])

      ]
     ])
  )

(defn get-it []
  (let [!st (r/atom {:invalidated true :data {} :opened {}})
        !me (r/cursor v-state/app-state [:me])
        ]
    (fn []
      (js/console.log "rights_manager rerender" @!st)
      [mui/list


       [mui/list-item {}

        [mui/card {:style {:maxWidth "1200px" :width "100%"}}
         [my-cockpit !me]
         ]]

       [mui/list-item {}

        [mui/card {:style {:maxWidth "1200px" :width "100%"}}
         [my-email-setup !st !me]
         ]]

       [mui/list-item {}
        [mui/card {:style {:maxWidth "1200px" :width "100%"}}
         [my-rights !me]
         ]]

       ;[mui/list-item {}
       ; [mui/card {:style {:maxWidth "1200px" :width "100%"}}
       ;  [mui/card-content
       ;   [:pre (clojure.string/replace (pr-str @!me) #"," ",\n")]
       ;   ]
       ;  ]]

       ]

      )))
